import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-version-panel',
  standalone: true,
  templateUrl: './app-version-panel.component.html',
  styleUrl: './app-version-panel.component.css'
})
export class AppVersionPanelComponent {
  readonly environmentName: string = environment.ENVIRONMENT_MAP_INTERNAL_ID;
  readonly version: string = environment.AH_DASH_FE_02_VERSION;
  readonly isProduction: boolean = environment.IS_PRODUCTION;
}
